export default __webpack_public_path__ + "static/media/Y_wdt_c_cap_3.800d7804.mp3";